import { createI18n } from "vue-i18n";
import en from "./lang/en.json"
import tr from "./lang/tr.json"
import de from "./lang/de.json"
import nl from "./lang/nl.json"
import fr from "./lang/fr.json"
import es from "./lang/es.json"
import pt from "./lang/pt.json"
import it from "./lang/it.json"
import ru from "./lang/ru.json"

const DEFAULT_LOCALE = "en";

const locales = [
  { code: "en", iso: "en-US", name: "English" },
  { code: "tr", iso: "tr-TR", name: "Türkçe" },
  { code: "de", iso: "de-DE", name: "Deutsch" },
  { code: "nl", iso: "nl-NL", name: "Dutch" },
  { code: "fr", iso: "fr-FR", name: "French" },
  { code: "es", iso: "es-ES", name: "Spanish" },
  { code: "pt", iso: "pt-PT", name: "Portuguese" },
  { code: "it", iso: "it-IT", name: "Italian" },
  { code: "ru", iso: "ru-RU", name: "Russian" }
];

const findLocale = (value?: string | null) => {
  if (!value) {
    return undefined;
  }

  const normalizedValue = String(value).trim().toLowerCase();

  let matchedLocale = locales.find((locale) => {
    return locale.code.toLowerCase() === normalizedValue || locale.iso.toLowerCase() === normalizedValue;
  });

  if (!matchedLocale && normalizedValue.includes("-")) {
    const languageCode = normalizedValue.split("-")[0];
    matchedLocale = locales.find((locale) => locale.code.toLowerCase() === languageCode);
  }

  return matchedLocale;
};

const resolveLocale = (value?: string | null, fallback = DEFAULT_LOCALE) => {
  return findLocale(value)?.code || fallback;
};

const getPreferredLocale = () => {
  const savedLocale = typeof window !== "undefined" ? localStorage.getItem("lang") : null;

  if (savedLocale) {
    return resolveLocale(savedLocale);
  }

  const browserLocale = typeof navigator !== "undefined" ? navigator.language : null;
  return resolveLocale(browserLocale);
};

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  globalInjection: true,
  messages: {
    en: en,
    tr: tr,
    de: de,
    nl: nl,
    fr: fr,
    es: es,
    pt: pt,
    it: it,
    ru: ru
  }
});

export default i18n;
export { DEFAULT_LOCALE, locales, findLocale, resolveLocale, getPreferredLocale };
